import Moment from 'moment';
import SystemFieldProto from '../../proto/system-field-proto';
import AggregateMoment from "../../aggregate/aggregate-moment";
import AggregateMomentComponent from "../components/aggregate-moment";
import normalizeDate from "../../import/normalize/normalize-date";
import FieldDateViewInImport from "../../import/view-in-preview/date-view-in-import";

export default class StartDateField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.START_DATE;
    }

    get sortHintMessage() {
        return 'Sort by start date';
    }

    getCsvValue(item) {
        const { startDate } = item;
        return startDate ? Moment(startDate).format("YYYY-MM-DD") : '';
    }

    getValue(item) {return item.startDate}

    getAggregateClass() {return AggregateMoment}
    getAggregateOptions() {return [
        gd.const.aggregate.type.MIN,
        gd.const.aggregate.type.MAX,
        gd.const.aggregate.type.RANGE
    ]}

    listItemSortFunctions(sort) {
        return {
            functions: [i => Moment(i.item.startDate || '1900-01-01 00:00:00').unix()],
            directions: [sort]
        }
    }

    get AggregateComponent() {return AggregateMomentComponent.bind(null, this.getAggregateOptions())}


    // IMPORT

    normalizeCSVValue(value) {
        return normalizeDate(value);
    }

    getComponentViewInImport() {
        return FieldDateViewInImport;
    }

}